module.exports = __webpack_public_path__ + "img/ALLERGIC_CAT.ae0b5b0e.svg";